import { defineMessages } from "react-intl";

export const fieldMessages = defineMessages({
  clearInput: {
    id: "field.ariaClearInput",
    description: "Button label that clears the current text from the field",
    defaultMessage: "Clear input",
  },
});
